import { Type } from '@sinclair/typebox';
import { createClientError } from '../core/create-client-error.js';
export const SharePointProjectNotFoundError = createClientError('SHAREPOINT_PROJECT_NOT_FOUND', Type.Object({}));
